import { Link } from "react-router-dom";
import { Github, Linkedin, Twitter, Mail } from "lucide-react";

export function Footer({ profile }) {
  const year = new Date().getFullYear();
  return (
    <footer className="relative mt-32 border-t border-border" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-6 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <div className="font-heading text-xl font-semibold tracking-tight">{profile?.name || "Sandeep Varikuppala"}</div>
          <p className="mt-3 text-sm text-muted-foreground max-w-xs leading-relaxed">
            {profile?.tagline || "Frontend developer crafting premium, accessible interfaces."}
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">Explore</div>
          <div className="grid grid-cols-2 gap-2 text-sm">
            <Link to="/about" className="text-muted-foreground hover:text-foreground transition-colors">About</Link>
            <Link to="/skills" className="text-muted-foreground hover:text-foreground transition-colors">Skills</Link>
            <Link to="/projects" className="text-muted-foreground hover:text-foreground transition-colors">Projects</Link>
            <Link to="/blog" className="text-muted-foreground hover:text-foreground transition-colors">Blog</Link>
            <Link to="/resume" className="text-muted-foreground hover:text-foreground transition-colors">Resume</Link>
            <Link to="/contact" className="text-muted-foreground hover:text-foreground transition-colors">Contact</Link>
            <Link to="/book" className="text-muted-foreground hover:text-foreground transition-colors">Book a Call</Link>
          </div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">Connect</div>
          <div className="flex gap-3">
            {[
              { icon: Github, href: profile?.github, key: "github" },
              { icon: Linkedin, href: profile?.linkedin, key: "linkedin" },
              { icon: Twitter, href: profile?.twitter, key: "twitter" },
              { icon: Mail, href: profile?.email ? `mailto:${profile.email}` : "#", key: "mail" },
            ].map(({ icon: Icon, href, key }) => (
              <a
                key={key}
                href={href || "#"}
                target="_blank"
                rel="noreferrer"
                data-testid={`footer-social-${key}`}
                className="h-10 w-10 grid place-items-center rounded-full glass hover:scale-105 transition-transform"
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="max-w-6xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-muted-foreground">
          <span>© {year} {profile?.name || "Sandeep Varikuppala"}. Built with React, FastAPI & MongoDB.</span>
        </div>
      </div>
    </footer>
  );
}
